// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import RichText from '@tcp/core/src/components/common/atoms/RichText';

const tabletString = 'tablet';
const desktopString = 'desktop';

export const Container = styled.div`
  text-align: left;
  @media ${(props) => props.theme.mediaQuery.large} {
    display: ${(props) => (props.viewMode === tabletString ? 'none' : 'block')};
    ${(props) =>
      props.addExtraMarginLeft ? `margin-left: ${props.theme.spacing.ELEM_SPACING.MED_1}` : ''}
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    display: ${(props) => (props.viewMode === desktopString ? 'none' : 'block')};
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    display: ${(props) => (props.viewMode === desktopString ? 'none' : 'block')};
    margin: 0 15px;
  }
  ${(props) => (props.isSeoHeaderCopyEmpty ? `display: none` : '')};
`;

export const RenderText = styled(RichText)`
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  font-size: ${(props) => props.theme.typography.fontSizes.fs22};
  font-weight: ${(props) => props.theme.typography.fontWeights.bold};
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  color: ${(props) => props.theme.colors.BLACK};
  padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    line-height: 1.21;
  }

  h1 {
    font-size: ${(props) => props.theme.typography.fontSizes.fs22};
    font-weight: ${(props) => props.theme.typography.fontWeights.bold};
    margin: 0;
  }
`;

export const SeoTitleSkeleton = styled.div`
  box-sizing: border-box;
  margin: 0 15px;
  padding: 0;
  overflow: hidden;
  position: relative;
  width: 50%;
  max-width: 240px;
  height: 24px;
  display: ${(props) => (props.viewMode === desktopString ? 'none' : 'block')};

  @media ${(props) => props.theme.mediaQuery.large} {
    margin: 0 0 32px;
    width: 240px;
    height: 36px;
    display: ${(props) => (props.viewMode === tabletString ? 'none' : 'block')};
  }
`;

export const SeoTitle = styled(RichText)`
  &,
  & h1,
  & p {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: #000;
    font-family: Nunito;
    font-size: 15px;
    font-style: normal;
    font-weight: 800;
    line-height: 150%;
    text-transform: capitalize;
    display: ${(props) => (props.viewMode === desktopString ? 'none' : 'block')};

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: 24px;
      display: ${(props) => (props.viewMode === tabletString ? 'none' : 'block')};
    }
  }

  &.category-title {
    margin: 0 15px;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 0 0 32px;
    }
  }
`;
